import { __assign, __awaiter, __extends, __generator, __read } from "tslib";
import { queryCache } from '@office-start/data-fetching';
import { Module } from '.';
import { ModuleError } from './ModuleError';
var SearchInstrumenter = /** @class */ (function (_super) {
    __extends(SearchInstrumenter, _super);
    function SearchInstrumenter(searchSettings, searchModules) {
        var _this = _super.call(this, 'Search_Instrumenter') || this;
        _this.bingSuggestionsAppID = 'D41D8CD98F00B204E9800998ECF8427E0C818072';
        _this.searchSettings = searchSettings;
        _this.searchModules = searchModules;
        return _this;
    }
    SearchInstrumenter.prototype.initializeModule = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, searchInstrumentationModule, hostAppId, identity, officeComponentContext, ring, searchEnvironment, searchCloudUrls, isMsa, instrumenter;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            this.fetchModule(),
                            this.searchSettings.getHostAppId(),
                            this.searchSettings.getIdentity(),
                            this.searchSettings.getOfficeComponentContext(),
                            this.searchSettings.getRing(),
                            this.searchSettings.getSearchEnvironment(),
                            this.searchSettings.getSearchCloudUrls(),
                        ])];
                    case 1:
                        _a = __read.apply(void 0, [_b.sent(), 7]), searchInstrumentationModule = _a[0], hostAppId = _a[1], identity = _a[2], officeComponentContext = _a[3], ring = _a[4], searchEnvironment = _a[5], searchCloudUrls = _a[6];
                        try {
                            isMsa = identity.isMsa;
                            instrumenter = searchInstrumentationModule.createInstrumenter(__assign({ perf: window.performance, scenario: '', hostAppInfo: {
                                    id: hostAppId,
                                    version: officeComponentContext.buildVersion,
                                    userRing: ring,
                                    variant: 'React',
                                }, serviceEnvInfo: {
                                    environment: searchEnvironment,
                                    urls: searchCloudUrls,
                                } }, (isMsa && {
                                bingConsumerApiContext: {
                                    appId: this.bingSuggestionsAppID,
                                    viewerId: identity.puid,
                                    fromPhotos: false,
                                },
                            })));
                            instrumenter.markAppBoot();
                            this.module.resolve(instrumenter);
                        }
                        catch (_) {
                            throw new ModuleError('Search_Prefetch', 'Initialization_Error');
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    SearchInstrumenter.prototype.fetchModule = function () {
        return __awaiter(this, void 0, void 0, function () {
            var searchModules, query;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.searchModules.getModule()];
                    case 1:
                        searchModules = _a.sent();
                        query = ['SearchInstrumentationModule'];
                        return [2 /*return*/, queryCache.fetchQuery(query, function () { return searchModules.loadSearchInstrumentation(); }, {
                                cacheTime: Infinity,
                                staleTime: Infinity,
                                onError: function () {
                                    throw new ModuleError('Search_Prefetch', 'Fetching_Error');
                                },
                            })];
                }
            });
        });
    };
    return SearchInstrumenter;
}(Module));
export { SearchInstrumenter };
//# sourceMappingURL=SearchInstrumenter.js.map